import { Component, type ErrorInfo, type ReactNode } from 'react';
import * as Sentry from '@sentry/react';

interface Props {
  children: ReactNode;
  routeName?: string;
}

interface State {
  hasError: boolean;
  error: Error | null;
}

export class RouteErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false, error: null };

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    try {
      Sentry.captureException(error, {
        extra: { routeName: this.props.routeName, componentStack: info.componentStack },
      });
    } catch {
      // ignore
    }
  }

  reset = () => this.setState({ hasError: false, error: null });

  render() {
    if (this.state.hasError) {
      return (
        <div style={{ padding: 32, textAlign: 'center' }}>
          <h2>Something went wrong on this page.</h2>
          <p>The error has been reported. You can try again or go home.</p>
          <button onClick={this.reset} style={{ marginRight: 8 }}>
            Retry
          </button>
          <a href="/">Go home</a>
        </div>
      );
    }
    return this.props.children;
  }
}

export default RouteErrorBoundary;
